// Function to convert base64 to ArrayBuffer
export const base64ToArrayBuffer = (base64) => {
    const binaryString = window.atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
  };
  
  // Function to decrypt AES-encrypted data
  export const decryptAES = async (encryptedData, key) => {
    const data = base64ToArrayBuffer(encryptedData);
    const iv = data.slice(0, 16); // Extract IV (first 16 bytes)
    const ciphertext = data.slice(16); // The rest is the ciphertext
  
    // Convert key to CryptoKey object
    const cryptoKey = await window.crypto.subtle.importKey(
      'raw',
      new TextEncoder().encode(key), // Convert key to Uint8Array
      { name: 'AES-CBC' },
      false,
      ['decrypt']
    );
  
    try {
      // Decrypt the data
      const decryptedArrayBuffer = await window.crypto.subtle.decrypt(
        { name: 'AES-CBC', iv: iv },
        cryptoKey,
        ciphertext
      );
  
      // Convert decrypted data back to string
      const decryptedText = new TextDecoder().decode(decryptedArrayBuffer);
      return decryptedText;
    } catch (error) {
      console.error('Decryption failed:', error);
      return null;
    }
  };
export const encryptAES = async (plainText, key) => {
  try {
    const cryptoKey = await crypto.subtle.importKey(
      "raw",
      new TextEncoder().encode(key),
      { name: "AES-CBC" },
      false,
      ["encrypt"]
    );

    const iv = crypto.getRandomValues(new Uint8Array(16));

    const encryptedBuffer = await crypto.subtle.encrypt(
      { name: "AES-CBC", iv },
      cryptoKey,
      new TextEncoder().encode(plainText)
    );

    const combined = new Uint8Array(iv.length + encryptedBuffer.byteLength);
    combined.set(iv, 0);
    combined.set(new Uint8Array(encryptedBuffer), iv.length);

    let binary = "";
    combined.forEach(b => (binary += String.fromCharCode(b)));

    return btoa(binary);   // THIS MUST BE RETURNED

  } catch (e) {
    console.error("Encryption failed:", e);
    return null;
  }
};
